// extracted by mini-css-extract-plugin
module.exports = {"item":"_80ad21f8ef--item--2bn0n","item-title":"_80ad21f8ef--item-title--3s6zO","item-text":"_80ad21f8ef--item-text--2_F5b","label":"_80ad21f8ef--label--21z-r"};